import eastroom from './../assets/images/works/eastroom.jpg';
import oshawa from './../assets/images/works/oshawa.jpg';
import newmarket from './../assets/images/works/newmarket.jpg';
import claremont from './../assets/images/works/claremont.jpg';

export const projectsData = [
  {
    id: 1,
    title: 'Eastroom - Hullmark, 507 King St East',
    location: 'Toronto, Ontario',
    value: '$N/A',
    img: eastroom,
  },
  {
    id: 2,
    title: '101 Park Rd, Oshawa',
    location: 'Oshawa, Ontario',
    value: '$354 000',
    img: oshawa,
  },
  {
    id: 3,
    title: 'Eastroom - Dreamwork, 68 Claremont St',
    location: 'Toronto, Ontario',
    value: '$N/A',
    img: claremont,
  },
  {
    id: 4,
    title: '19585 Kennedy Rd',
    location: 'East Gwillimbury, Ontario',
    value: '$535 000',
    img: newmarket,
  },
];